import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { V_URL } from "../../../../../BaseUrl";
import Swal from "sweetalert2";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Footer from "../../../Include/Footer";
import { Pagination, Search } from "../../../Table";
import Loader from "../../../Include/Loader";
import DropDown from "../../../../../Components/DropDown";
import moment from "moment";
import { getDeliveryChallan } from "../../../../../Store/prosafe/proTransaction/Challan/getDeliveryChallan";

const DeliveryChallanList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [disable, setDisable] = useState(true);
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [limit, setlimit] = useState(10);

    const handleSearch = (value) => {
        setSearch(value);
        setCurrentPage(1);
    };

    useEffect(() => {
        setDisable(true);
    }, [currentPage, limit, search]);

    useEffect(() => {
        if (disable === true) {
            const payload = {
                search: search,
                page: currentPage,
                limit: limit,
                firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
                year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
            };
            dispatch(getDeliveryChallan({ formData: payload }));
            setDisable(false);
        }
    }, [disable, currentPage, limit, search]);

    const entity = useSelector((state) => state?.getDeliveryChallan?.user?.data);

    const challanData = entity?.data || [];
    const pagination = entity?.pagination;

    useEffect(() => {
        if (pagination?.total) {
            setTotalItems(pagination?.total);
        }
    }, [pagination]);

    const handleRefresh = () => {
        setDisable(true);
        setSearch("");
        setCurrentPage(1);
    };

    const handleDownloadChallan = async (id) => {
        try {

            const myurl = `${V_URL}/prosafe/download-delivery-challan/${id}`;
            axios({
                method: "get",
                url: myurl,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
                },
            })
                .then((response) => {
                    if (response.data.success === true) {
                        toast.success(response?.data?.message);
                        window.open(response?.data?.data?.pdfUrl, "_blank");
                        setDisable(true);
                    } else {
                        toast.error(response?.data?.message);
                    }
                })
                .catch((error) => {
                    toast.error(
                        error?.response?.data?.message || "Something went wrong"
                    );
                });
        } catch (err) {
            console.log(err)
        }

    };


    const handleDelete = (id, title) => {
        Swal.fire({
            title: `Are you sure want to delete ${title}?`,
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                const myurl = `${V_URL}/prosafe/delete-delivery-challan/${id}`;
                axios({
                    method: "delete",
                    url: myurl,
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
                    },
                })
                    .then((response) => {
                        if (response.data.success === true) {
                            toast.success(response?.data?.message);
                            setDisable(true);
                        } else {
                            toast.error(response?.data?.message);
                        }
                    })
                    .catch((error) => {
                        toast.error(
                            error?.response?.data?.message || "Something went wrong"
                        );
                    });
            }
        });
    };

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/main-store/user/dashboard">Dashboard </Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <i className="feather-chevron-right"></i>
                                    </li>
                                    <li className="breadcrumb-item active">Delivery Challan</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card card-table show-entire">
                                <div className="card-body">
                                    <div className="page-table-header mb-2">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <div className="doctor-table-blk">
                                                    <h3>Delivery Challan</h3>
                                                    <div className="doctor-search-blk">
                                                        <div className="top-nav-search table-search-blk">
                                                            <form onSubmit={(e) => e.preventDefault()}>
                                                                <Search onSearch={handleSearch} />
                                                                <button type="button" className="btn">
                                                                    <img
                                                                        src="/assets/img/icons/search-normal.svg"
                                                                        alt="firm-searchBox"
                                                                    />
                                                                </button>
                                                            </form>
                                                        </div>
                                                        <div className="add-group">
                                                            <Link
                                                                to="/main-store/user/manage-delivery-challan"
                                                                className="btn btn-primary add-pluss ms-2"
                                                                title="Add"
                                                            >
                                                                <img
                                                                    src="/assets/img/icons/plus.svg"
                                                                    alt="plus-icon"
                                                                />
                                                            </Link>
                                                            <button
                                                                type="button"
                                                                onClick={handleRefresh}
                                                                className="btn btn-primary doctor-refresh ms-2"
                                                                title="Refresh"
                                                            >
                                                                <img
                                                                    src="/assets/img/icons/re-fresh.svg"
                                                                    alt="refresh"
                                                                />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                                                <DropDown
                                                    limit={limit}
                                                    onLimitChange={(val) => {
                                                        setlimit(val);
                                                        setCurrentPage(1);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {disable === false ? (
                                        <div className="table-responsive">
                                            <table className="table border-0 custom-table comman-table  mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Sr.</th>
                                                        <th>Date</th>
                                                        <th>Challan No.</th>
                                                        <th>Project</th>
                                                        <th>Project No</th>
                                                        <th>Item Count</th>
                                                        <th>Total Qty</th>
                                                        <th>Total Amount</th>
                                                        <th className="text-end">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {challanData?.map((elem, i) => (
                                                        <tr key={elem?._id}>
                                                            <td>{(currentPage - 1) * limit + i + 1}</td>
                                                            <td>{elem?.date ? moment(elem.date).format("YYYY-MM-DD") : "-"}</td>
                                                            <td>{elem?.challan_no || "-"}</td>
                                                            <td>{`${elem.projectDetails?.name} ${elem.projectDetails?.project_no
                                                                ? `(${elem.projectDetails?.project_no})`
                                                                : ""
                                                                }` || "-"}</td>
                                                            <td>{elem?.manual_project_no || "-"}</td>
                                                            <td>{elem?.item_count || "-"}</td>
                                                            <td>{elem?.total_qty || "-"}</td>
                                                            <td>{elem?.total_amount || "-"}</td>
                                                            <td className="text-end">
                                                                <div className="dropdown dropdown-action">
                                                                    <a
                                                                        href="#"
                                                                        className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown"
                                                                        aria-expanded="false"
                                                                    >
                                                                        <i className="fa fa-ellipsis-v"></i>
                                                                    </a>
                                                                    <div className="dropdown-menu dropdown-menu-end">
                                                                        <button
                                                                            type="button"
                                                                            className="dropdown-item"
                                                                            onClick={() =>
                                                                                navigate(
                                                                                    `/main-store/user/view-delivery-challan`,
                                                                                    { state: elem }
                                                                                )
                                                                            }
                                                                        >
                                                                            <i className="fa-solid fa-eye m-r-5"></i>{" "}
                                                                            View
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            className="dropdown-item"
                                                                            onClick={() =>
                                                                                navigate(
                                                                                    `/main-store/user/manage-delivery-challan`,
                                                                                    { state: elem }
                                                                                )
                                                                            }
                                                                        >
                                                                            <i className="fa-solid fa-pen-to-square m-r-5"></i>{" "}
                                                                            Edit
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            className="dropdown-item"
                                                                            onClick={() =>
                                                                                handleDelete(elem?._id, elem.challan_no)
                                                                            }
                                                                        >
                                                                            <i className="fa fa-trash-alt m-r-5"></i>{" "}
                                                                            Delete
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            className="dropdown-item"
                                                                            onClick={() =>
                                                                                handleDownloadChallan(elem?._id)
                                                                            }
                                                                        >
                                                                            <i className="fa fa-download m-r-5"></i>{" "}
                                                                            Download Challan
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {challanData?.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="999">
                                                                <div className="no-table-data">
                                                                    No Data Found!
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ) : null}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <>
                                            <Loader />
                                        </>
                                    )
                                    }

                                    <div className="row align-center mt-3 mb-2">
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                            <div
                                                className="dataTables_info"
                                                id="DataTables_Table_0_info"
                                                role="status"
                                                aria-live="polite"
                                            >
                                                Showing {Math.min(limit, totalItems)} from{" "}
                                                {totalItems} data
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                            <div
                                                className="dataTables_paginate paging_simple_numbers"
                                                id="DataTables_Table_0_paginate"
                                            >
                                                <Pagination
                                                    total={totalItems}
                                                    itemsPerPage={limit}
                                                    currentPage={currentPage}
                                                    onPageChange={(page) => setCurrentPage(page)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div >
    );
};

export default DeliveryChallanList;
